class GeekoLoadMore extends HTMLElement {
  constructor() {
    super();
    this.data_page_count=0;
    this.addEventListener('click', this.loadMoreProducts.bind(this));
    this.next_url = document.getElementById('product-grid').dataset.nextUrl;
    this.loadMoreBtn = this.querySelector('.button');
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    this.loading = false;

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this.loadMoreProducts();
      });
    }, { rootMargin: '200px 0px' });
    this.observer.observe(this);

  }
  async getNextPage() {
    try {
      let res = await fetch(this.next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    } 
  }
  async loadMoreProducts() {
    if (this.loading || !this.next_url) return;
    this.loading = true;
    const load_more_spinner = this.getElementsByClassName('load-more_spinner')[0];
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await this.getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    load_more_spinner.style.display = 'none';
    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const temp = new_products;
    const new_url = productgrid.dataset.nextUrl;
    // if (new_url) {
    //   if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'inline-flex';
    // }
    this.next_url = new_url;
    let currentIndex = 0;
    while (new_products.length > currentIndex) {
      let product = new_products[currentIndex];
      if(product.classList.contains('wbimgbnrblock')) {
        currentIndex++;
        continue;
      };
      document.getElementById('product-grid').appendChild(product);
    } 
    this.loading = false;
    this.data_page_count=this.data_page_count+1;
    if (!this.next_url && this.observer) {
      this.observer.disconnect();
      reutrn;
    }
    if(this.data_page_count>=3){
      if(this.observer){
        this.observer.disconnect();
      }
      if(this.next_url){
        if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'inline-flex';
      }
    }
  }
  //必须加：组件从 DOM 移除时自动清理 observer
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
customElements.define('geeko-load-more', GeekoLoadMore);

/* ShopBuzz 站内信消息点击埋点 */
(function () {
  if (window.__geekoInboxMessageBound) return;
  window.__geekoInboxMessageBound = true;

  // ShopBuzz 跳转地址不在 DOM，而在 BUZZ_CAMPAIGN_DRAFTS.payload.buttonLink
  function findCampaignDraft(campaignId) {
    const id = String(campaignId || '');
    if (!id) return null;
    const data = window.BUZZ_CAMPAIGN_DRAFTS;
    if (!data) return null;

    function match(list) {
      if (!Array.isArray(list)) return null;
      for (let i = 0; i < list.length; i++) {
        if (list[i] && String(list[i].id) === id) return list[i];
      }
      return null;
    }

    const byFeed = data.byFeedType || {};
    return (
      match(byFeed.notifeed) ||
      match(byFeed.notisell) ||
      match(data.drafts) ||
      null
    );
  }

  function normalizeLink(url) {
    const u = String(url || '').trim();
    if (!u) return '';
    if (/^https?:\/\//i.test(u)) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return 'https://' + u.replace(/^\/+/, '');
  }

  function getDestinationHref(campaignId) {
    const draft = findCampaignDraft(campaignId);
    const payload = (draft && draft.payload) || {};
    return normalizeLink(payload.buttonLink);
  }
  function getCampaignName(campaignId) {
    const draft = findCampaignDraft(campaignId);
    const payload = (draft && draft.payload) || {};
    return payload.campaignName;
  }

  function getPathFromHref(href) {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname + url.search;
    } catch (err) {
      return href;
    }
  }

  function onArticleClick(e) {
    const list = e.currentTarget;
    const card = e.target.closest('article');
    if (!card || !list.contains(card)) return;

    const campaignId = card.getAttribute('data-campaign-id') || '';
    const href = getDestinationHref(campaignId);

    if (
      typeof Shopify === 'undefined' ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== 'function'
    ) {
      return;
    }

    Shopify.analytics.publish('geeko_inbox_message', {
      campaign_id: campaignId,
      campaign_name:getCampaignName(campaignId),
      path: getPathFromHref(href),
      url: href,
      page: window.location.pathname + window.location.search,
      timestamp: Date.now(),
    });
  }

  function bindList(list) {
    if (!list || list.dataset.geekoInboxBound === '1') return;
    list.dataset.geekoInboxBound = '1';
    // 捕获阶段：避免 ShopBuzz stopPropagation 导致收不到
    list.addEventListener('click', onArticleClick, true);
  }

  function tryBind() {
    bindList(document.getElementById('buzzNotifeedList'));
  }

  tryBind();

  const observer = new MutationObserver(function () {
    const list = document.getElementById('buzzNotifeedList');
    if (!list) return;
    bindList(list);
    observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ShopBuzz 站内信消息展示埋点：#atmPanel 出现 is-open 后上报每条消息 impression */
(function () {
  if (window.__geekoInboxImpressionBound) return;
  window.__geekoInboxImpressionBound = true;

  function findCampaignDraft(campaignId) {
    const id = String(campaignId || '');
    if (!id) return null;
    const data = window.BUZZ_CAMPAIGN_DRAFTS;
    if (!data) return null;

    function match(list) {
      if (!Array.isArray(list)) return null;
      for (let i = 0; i < list.length; i++) {
        if (list[i] && String(list[i].id) === id) return list[i];
      }
      return null;
    }

    const byFeed = data.byFeedType || {};
    return (
      match(byFeed.notifeed) ||
      match(byFeed.notisell) ||
      match(data.drafts) ||
      null
    );
  }

  function normalizeLink(url) {
    const u = String(url || '').trim();
    if (!u) return '';
    if (/^https?:\/\//i.test(u)) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return 'https://' + u.replace(/^\/+/, '');
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(html || '');
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function getPathFromHref(href) {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname + url.search;
    } catch (err) {
      return href;
    }
  }

  function getCampaignMeta(campaignId, card) {
    const draft = findCampaignDraft(campaignId);
    const payload = (draft && draft.payload) || {};
    const href = normalizeLink(payload.buttonLink);
    const titleEl = card && card.querySelector('.buzz-nf-card__title');
    const campaignName =
      (draft && (draft.campaignName || draft.name)) ||
      payload.campaignName ||
      payload.name ||
      stripHtml(payload.notificationTitle) ||
      (titleEl ? (titleEl.textContent || '').trim() : '') ||
      '';
    return { href, campaignName };
  }

  function publishImpressions() {
    if (
      typeof Shopify === 'undefined' ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== 'function'
    ) {
      return false;
    }

    const panel = document.getElementById('atmPanel');
    if (!panel || !panel.classList.contains('is-open') || panel.classList.contains('is-closing')) {
      return false;
    }

    const cards = panel.querySelectorAll('#buzzNotifeedList article[data-campaign-id]');
    if (!cards.length) return false;

    // 同一次打开只报一轮
    if (panel.dataset.geekoImpressionOpen === '1') return true;
    panel.dataset.geekoImpressionOpen = '1';

    const page = window.location.pathname + window.location.search;
    const timestamp = Date.now();

    Array.prototype.forEach.call(cards, function (card) {
      const campaignId = card.getAttribute('data-campaign-id') || '';
      const meta = getCampaignMeta(campaignId, card);
      Shopify.analytics.publish('geeko_inbox_message_impression', {
        campaign_id: campaignId,
        campaign_name: meta.campaignName,
        path: getPathFromHref(meta.href),
        url: meta.href,
        page: page,
        timestamp: timestamp,
      });
    });
    return true;
  }

  function schedulePublishImpressions() {
    let tries = 0;
    const timer = setInterval(function () {
      tries += 1;
      if (publishImpressions() || tries >= 20) clearInterval(timer);
    }, 100);
  }

  function onPanelClassChange() {
    const panel = document.getElementById('atmPanel');
    if (!panel) return;

    if (panel.classList.contains('is-open') && !panel.classList.contains('is-closing')) {
      schedulePublishImpressions();
    } else {
      panel.dataset.geekoImpressionOpen = '';
    }
  }

  function bindPanel(panel) {
    if (!panel || panel.dataset.geekoImpressionWatch === '1') return;
    panel.dataset.geekoImpressionWatch = '1';

    const observer = new MutationObserver(onPanelClassChange);
    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });

    if (panel.classList.contains('is-open')) onPanelClassChange();
  }

  function tryBind() {
    bindPanel(document.getElementById('atmPanel'));
  }

  tryBind();

  const rootObserver = new MutationObserver(function () {
    const panel = document.getElementById('atmPanel');
    if (!panel) return;
    bindPanel(panel);
    rootObserver.disconnect();
  });
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
})();